// Platform notifications API client (#259 / backend #163). Same auth pattern as
// billingApi/iamApi: a dedicated axios instance on the shared `/api` base with
// the bearer + active-org interceptor.
import axios from 'axios';
import { resolveApiBaseUrl } from './resolveApiBaseUrl';
import { attachAuth } from './authToken';

const base = resolveApiBaseUrl(); // ends with /api
const client = axios.create({ baseURL: base });
client.interceptors.request.use(attachAuth);

const d = (p) => p.then((r) => r.data);

export const notificationsApi = {
  // params: { state?, limit?, cursor? }
  list: (params = {}) => d(client.get('/notifications', { params })),
  unseenCount: () => d(client.get('/notifications/unseen-count')),
  // GET marks the receipt `viewed` server-side (auto).
  get: (id) => d(client.get(`/notifications/${id}`)),
  // Mark the given ids seen (driven by rows scrolling into view).
  seen: (ids) => d(client.post('/notifications/seen', { ids })),
  // action: 'addressed' | 'dismissed' | 'close'
  action: (id, action) => d(client.post(`/notifications/${id}/action`, { action })),
  // super-admin: emit (platform announcements / seeding).
  adminEmit: (payload) => d(client.post('/notifications/admin/emit', payload)),
};

export default notificationsApi;
